<template>
  <div class="flex flex-col gap-4">
    <div v-for="part in parts">
      <input
        type="checkbox"
        name="subPartCode"
        :id="part.id"
        :key="part.id"
        :value="part.id"
        :checked="internalValue === part.id"
        class="peer hidden"
        @input="onChange(part.id)"
      />
      <Label :val="part.id" :id="part.id" :name="part.name" :internalValue="internalValue" :onChange="onChange" />
    </div>
  </div>
</template>
<script>
import Label from '@/components/ui/label';
export default {
  name: 'ChoosePart',
  components: { Label },
  props: {
    areaCode: {
      required: true,
    },
    subPartCode: {
      required: true,
    },
    value: {
      required: true,
    },
    dir: {
      required: false
    }
  },

  data() {
    return {
      showLoader: true,
      internalValue: null,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },

    parts: {
      immediate: true,
      handler(parts) {
       /* if (parts.length == 1) {
          this.onChange(parts[0].code);
        }*/
      },
    },
  },

  computed: {
    parts() {
      return this.$store.getters.getSubParts;
    },
    show() {
      return !!this.parts.length;
    },
  },
  methods: {
    onChange(value) {
        // Om användaren klickar på samma val igen → avmarkera
        if (this.internalValue === value) {
          this.internalValue = null;
          this.$emit('update:subPartCode', null);
        } else {
          this.internalValue = value;
          this.$emit('update:subPartCode', value);
        }
      },

    },


  created() {
    console.log("this.subPartCode", this.subPartCode)
    if (this.subPartCode && this.dir =="prev"){
      this.internalValue = this.subPartCode;
      this.$emit('update:subPartCode', this.internalValue);
    }
  },
};
</script>
